import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies'

//腾旭 tim 
import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'
//const SdkAppId = process.env.NODE_ENV === 'development' ?1400677294: 1400379671;
const SdkAppId = process.env.NODE_ENV === 'development' ?1400379671: 1400379671;
// 初始化 SDK 实例
const tim = TIM.create({
    SDKAppID: SdkAppId
})
window.setLogLevel = tim.setLogLevel;
// 无日志级别
tim.setLogLevel(4);
// 注册 cos
tim.registerPlugin({'cos-js-sdk':COSSDK});
window.tim = tim;
window.TIM = TIM;
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
Vue.prototype.SDKAPPID = SdkAppId



Vue.use(ElementUI);
Vue.use(VueCookies)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
